import { useToaster } from "hooks";
import { useAuth } from "hooks";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Desktop from "homepage/Desktop";
import { HomeFooter } from "homepage/homeFooter";
const Test = () => {
  const { token, removeToken } = useAuth();
  const navigate = useNavigate();
  const { setSuccessToaster, setErrorToaster } = useToaster();

  const handleSignOut = () => {
    removeToken();
    window.location.reload();
  };
  const handlePlansClick = (e) => {
    if (token) {
      navigate("/dashboard");
    } else if (e) {
      e.preventDefault();
      setErrorToaster("Please Log In");
    }
  };
  return (
    <>
      <nav className="layout-navbar shadow-none py-0" style={{position:'sticky',top:"0px"}}>
        <div className="container">
          <div className="navbar navbar-expand-lg landing-navbar px-3 px-md-4" style={{backgroundColor:"#fff"}}>
            <div className="navbar-brand app-brand demo d-flex py-0 py-lg-2 me-4">
              <button
                className="navbar-toggler border-0 px-0 me-2"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <i className="ti ti-menu-2 ti-sm align-middle" />
              </button>
              <Link href="/" className="app-brand-link">
                {/* <span class="app-brand-logo demo">
                  <svg
                    width="32"
                    height="22"
                    viewBox="0 0 32 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0.00172773 0V6.85398C0.00172773 6.85398 -0.133178 9.01207 1.98092 10.8388L13.6912 21.9964L19.7809 21.9181L18.8042 9.88248L16.4951 7.17289L9.23799 0H0.00172773Z"
                      fill="#7367F0"
                    />
                    <path
                      opacity="0.06"
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.69824 16.4364L12.5199 3.23696L16.5541 7.25596L7.69824 16.4364Z"
                      fill="#161616"
                    />
                    <path
                      opacity="0.06"
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.07751 15.9175L13.9419 4.63989L16.5849 7.28475L8.07751 15.9175Z"
                      fill="#161616"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.77295 16.3566L23.6563 0H32V6.88383C32 6.88383 31.8262 9.17836 30.6591 10.4057L19.7824 22H13.6938L7.77295 16.3566Z"
                      fill="#7367F0"
                    />
                  </svg>
                </span> */}
                <img
              src="../../assets/img/i.jpeg"
              alt="hero background"
              // data-speed={1}
              style={{width:"32px",
                height: "22px"
              }}
            />
                <span class="app-brand-text demo menu-text fw-bold ms-2 ps-1">
                  Zenosure
                </span>
              </Link>
            </div>
            <div
              className="collapse navbar-collapse landing-nav-menu"
              id="navbarSupportedContent"
            >
              <button
                className="navbar-toggler border-0 text-heading position-absolute end-0 top-0 scaleX-n1-rtl"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <i className="ti ti-x ti-sm" />
              </button>
              <ul className="navbar-nav me-auto">
                <li className="nav-item">
                  <Link
                    className="nav-link fw-medium"
                    aria-current="page"
                    to="/"
                  >
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/aboutus" className="nav-link fw-medium">
                    About us
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link fw-medium" to="/partnerwithus">
                    Partner with us
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link fw-medium" to="/faq">
                    FAQ
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link fw-medium" to="#">
                    Discover savings
                  </Link>
                </li>
                <li className="nav-item mega-dropdown">
                  <Link className="nav-link fw-medium" to="/checkMembership">
                    Check Membership
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    onClick={handlePlansClick}
                    className="nav-link fw-medium"
                    to="/plans"
                  >
                    Plans
                  </Link>
                </li>
                <li className="nav-item mega-dropdown">
                  <Link className="nav-link fw-medium" to="/contactUs">
                    Contact us
                  </Link>
                </li>
              </ul>
            </div>
            <div className="landing-menu-overlay d-lg-none" />
            <ul className="navbar-nav flex-row align-items-center ms-auto">
              <li className="nav-item dropdown-style-switcher dropdown me-2 me-xl-0">
                <a
                  className="nav-link dropdown-toggle hide-arrow"
                  href="javascript:void(0);"
                  data-bs-toggle="dropdown"
                >
                  <i className="ti ti-sm" />
                </a>
                <ul className="dropdown-menu dropdown-menu-end dropdown-styles">
                  <li>
                    <a
                      className="dropdown-item"
                      href="javascript:void(0);"
                      data-theme="light"
                    >
                      <span className="align-middle">
                        <i className="ti ti-sun me-2" />
                        Light
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="javascript:void(0);"
                      data-theme="dark"
                    >
                      <span className="align-middle">
                        <i className="ti ti-moon me-2" />
                        Dark
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="javascript:void(0);"
                      data-theme="system"
                    >
                      <span className="align-middle">
                        <i className="ti ti-device-desktop me-2" />
                        System
                      </span>
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                {/* <a
                  href="../vertical-menu-template/auth-login-cover.html"
                  className="btn btn-primary"
                  target="_blank"
                > */}
                {/* <span className="tf-icons ti ti-login scaleX-n1-rtl me-md-1" /> */}
                <span className="d-none d-md-block">
                  {token ? (
                    <button onClick={handleSignOut} className="btn btn-primary">
                      Sign Out
                    </button>
                  ) : (
                    <Link to="/login" className="btn btn-primary">
                      Sign In
                    </Link>
                  )}
                </span>
                {/* </a> */}
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div data-bs-spy="scroll" class="scrollspy-example">
        <section id="hero-animation" style={{marginTop:"-80px"}}>
          <div
            id="landingHero"
            className="section-py landing-hero position-relative"
          >
            <img
              src="../../assets/img/front-pages/backgrounds/hero-bg.png"
              alt="hero background"
              className="position-absolute top-0 start-50 translate-middle-x object-fit-contain w-100 h-100"
              data-speed={1}
            />
            <div className="container">
              <div className="hero-text-box text-center">
                <h1 className="text-primary hero-title display-6 fw-bold">
                  One dashboard to manage all your businesses
                </h1>
                <h2 className="hero-sub-title h6 mb-4 pb-1">
                  Production-ready &amp; easy to use Admin Template
                  <br className="d-none d-lg-block" />
                  for Reliability and Customizability.
                </h2>
                <div className="landing-hero-btn d-inline-block position-relative">
                  <span className="hero-btn-item position-absolute d-none d-md-flex text-heading">
                    Join community
                    <img
                      src="../../assets/img/front-pages/icons/Join-community-arrow.png"
                      alt="Join community arrow"
                      className="scaleX-n1-rtl"
                    />
                  </span>
                  <a href="#landingPricing" className="btn btn-primary btn-lg">
                    Get early access
                  </a>
                </div>
              </div>
              <div id="heroDashboardAnimation" className="hero-animation-img">
                <a href="#" target="_blank">
                  <div
                    id="heroAnimationImg"
                    className="position-relative hero-dashboard-img"
                  >
                    <img
                      src="../../assets/img/front-pages/landing-page/hero-dashboard-light.png"
                      alt="hero dashboard"
                      className="animation-img"
                      data-app-light-img="front-pages/landing-page/hero-dashboard-light.png"
                      data-app-dark-img="front-pages/landing-page/hero-dashboard-dark.png"
                    />
                    <img
                      src="../../assets/img/front-pages/landing-page/hero-elements-light.png"
                      alt="hero elementsteja"
                      className="position-absolute hero-elements-img animation-img top-0 start-0"
                      data-app-light-img="front-pages/landing-page/hero-elements-light.png"
                      data-app-dark-img="front-pages/landing-page/hero-elements-dark.png"
                    />
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className="landing-hero-blank" />
        </section>

        <section id="landingFeatures" className="section-py landing-features">
          <div className="container">
            <div className="text-center mb-3 pb-1">
              <span className="badge bg-label-primary">Useful Features</span>
            </div>
            <h3 className="text-center mb-1">
              <span className="position-relative fw-bold z-1">
                How It works
                <img
                  src="../../assets/img/front-pages/icons/section-title-icon.png"
                  alt="laptop charging"
                  className="section-title-img position-absolute object-fit-contain bottom-0 z-n1"
                />
              </span>
              {/* to start your next project */}
            </h3>
            <p className="text-center mb-3 mb-md-5 pb-3">
              Unlock Your Zenosure Benefits in Five Easy Steps
            </p>
            <div className="features-icon-wrapper row gx-0 gy-4 g-sm-5">
              <div className="col-lg-4 col-sm-6 text-center features-icon-box">
                <div className="text-center mb-3">
                  <img
                    src="../../assets/img/front-pages/icons/laptop.png"
                    alt="laptop charging"
                  />
                </div>
                <h5 className="mb-3">Register Online</h5>
                <p className="features-icon-description">
                  Start by signing up through our quick and secure online
                  registration process.
                </p>
              </div>
              <div className="col-lg-4 col-sm-6 text-center features-icon-box">
                <div className="text-center mb-3">
                  <img
                    src="../../assets/img/front-pages/icons/rocket.png"
                    alt="transition up"
                  />
                </div>
                <h5 className="mb-3">Choose Your Package</h5>
                <p className="features-icon-description">
                  Select the best subscription package for you, with options
                  tailored for individuals or families, each offering different
                  levels of benefits and savings.
                </p>
              </div>
              <div className="col-lg-4 col-sm-6 text-center features-icon-box">
                <div className="text-center mb-3">
                  <img
                    src="../../assets/img/front-pages/icons/paper.png"
                    alt="edit"
                  />
                </div>
                <h5 className="mb-3">Verify Identity</h5>
                <p className="features-icon-description">
                  Complete a fast KYC verification to gain immediate access to
                  services.
                </p>
              </div>
              <div className="col-lg-4 col-sm-6 text-center features-icon-box">
                <div className="text-center mb-3">
                  <img
                    src="../../assets/img/front-pages/icons/check.png"
                    alt="3d select solid"
                  />
                </div>
                <h5 className="mb-3">Receive Zenosure Card</h5>
                <p className="features-icon-description">
                  Get your ZenoSure card in both digital and physical formats.
                </p>
              </div>
              <div className="col-lg-4 col-sm-6 text-center features-icon-box">
                <div className="text-center mb-3">
                  <img
                    src="../../assets/img/front-pages/icons/user.png"
                    alt="lifebelt"
                  />
                </div>
                <h5 className="mb-3">
                  Present Your E-Card at Partner Locations
                </h5>
                <p className="features-icon-description">
                  Use your card at over 100+ partner locations, including
                  hospitals, pharmacies, and wellness centers, to avail of your
                  benefits instantly.
                </p>
              </div>
              <div className="col-lg-4 col-sm-6 text-center features-icon-box">
                <div className="text-center mb-3">
                  <img
                    src="../../assets/img/front-pages/icons/keyboard.png"
                    alt="google docs"
                  />
                </div>
                <h5 className="mb-3">Well Documented</h5>
                <p className="features-icon-description">
                  An easy-to-follow doc with lots of references and code
                  examples.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section
          id="landingReviews"
          className="section-py bg-body landing-reviews pb-0"
        >
          <div className="container ">
            <div className="row align-items-center gx-0 gy-4 g-lg-5">
              <div className="col-md-6 col-lg-5 col-xl-3">
                <div className="mb-3 pb-1">
                  <span className="badge bg-label-primary">
                    Real Customers Reviews
                  </span>
                </div>
                <h3 className="mb-1">
                  <span className="position-relative fw-bold z-1">
                    What people say
                    <img
                      src="../../assets/img/front-pages/icons/section-title-icon.png"
                      alt="laptop charging"
                      className="section-title-img position-absolute object-fit-contain bottom-0 z-n1"
                    />
                  </span>
                </h3>
                <p className="mb-3 mb-md-5">
                  See what our customers have to
                  <br className="d-none d-xl-block" />
                  say about their experience.
                </p>
                <div className="landing-reviews-btns">
                  <button
                    id="reviews-previous-btn"
                    className="btn btn-label-primary reviews-btn me-3 scaleX-n1-rtl"
                    type="button"
                  >
                    <i className="ti ti-chevron-left ti-sm" />
                  </button>
                  <button
                    id="reviews-next-btn"
                    className="btn btn-label-primary reviews-btn scaleX-n1-rtl"
                    type="button"
                  >
                    <i className="ti ti-chevron-right ti-sm" />
                  </button>
                </div>
              </div>
              <div class="col-md-6 col-lg-7 col-xl-9 ">
                <div class="swiper-reviews-carousel overflow-hidden mb-5 pb-md-2 pb-md-3">
                  <div class="swiper " id="swiper-reviews">
                    <div class="swiper-wrapper d-flex">
                      <div class="swiper-slide">
                        <div class="card h-100 ">
                          <div class="card-body text-body d-flex flex-column justify-content-between h-100">
                            <div class="mb-3">
                              <img
                                src="../../assets/img/front-pages/branding/logo-1.png"
                                alt="client logo"
                                class="client-logo img-fluid"
                              />
                            </div>
                            <p>
                              “Vuexy is hands down the most useful front end
                              Bootstrap theme I've ever used. I can't wait to
                              use it again for my next project.”
                            </p>
                            <div class="text-warning mb-3">
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star-filled ti-sm"></i>
                            </div>
                            <div class="d-flex align-items-center">
                              <div class="avatar me-2 avatar-sm">
                                <img
                                  src="../../assets/img/avatars/1.png"
                                  alt="Avatar"
                                  class="rounded-circle"
                                />
                              </div>
                              <div>
                                <h6 class="mb-0">Cecilia Payne</h6>
                                <p class="small text-muted mb-0">
                                  CEO of Airbnb
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div class="swiper-slide">
                        <div class="card h-100">
                          <div class="card-body text-body d-flex flex-column justify-content-between h-100">
                            <div class="mb-3">
                              <img
                                src="../../assets/img/front-pages/branding/logo-2.png"
                                alt="client logo"
                                class="client-logo img-fluid"
                              />
                            </div>
                            <p>
                              “I've never used a theme as versatile and flexible
                              as Vuexy. It's my go to for building dashboard
                              sites on almost any project.”
                            </p>
                            <div class="text-warning mb-3">
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star-filled ti-sm"></i>
                            </div>
                            <div class="d-flex align-items-center">
                              <div class="avatar me-2 avatar-sm">
                                <img
                                  src="../../assets/img/avatars/2.png"
                                  alt="Avatar"
                                  class="rounded-circle"
                                />
                              </div>
                              <div>
                                <h6 class="mb-0">Eugenia Moore</h6>
                                <p class="small text-muted mb-0">
                                  Founder of Hubspot
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}
                      <div class="swiper-slide">
                        <div class="card h-100">
                          <div class="card-body text-body d-flex flex-column justify-content-between h-100">
                            <div class="mb-3">
                              <img
                                src="../../assets/img/front-pages/branding/logo-3.png"
                                alt="client logo"
                                class="client-logo img-fluid"
                              />
                            </div>
                            <p>
                              This template is really clean & well documented.
                              The docs are really easy to understand and it's
                              always easy to find a screenshot from their
                              website.
                            </p>
                            <div class="text-warning mb-3">
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star-filled ti-sm"></i>
                            </div>
                            <div class="d-flex align-items-center">
                              <div class="avatar me-2 avatar-sm">
                                <img
                                  src="../../assets/img/avatars/3.png"
                                  alt="Avatar"
                                  class="rounded-circle"
                                />
                              </div>
                              <div>
                                <h6 class="mb-0">Curtis Fletcher</h6>
                                <p class="small text-muted mb-0">
                                  Design Lead at Dribbble
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div class="swiper-slide">
                        <div class="card h-100">
                          <div class="card-body text-body d-flex flex-column justify-content-between h-100">
                            <div class="mb-3">
                              <img
                                src="../../assets/img/front-pages/branding/logo-4.png"
                                alt="client logo"
                                class="client-logo img-fluid"
                              />
                            </div>
                            <p>
                              All the requirements for developers have been
                              taken into consideration, so I’m able to build any
                              interface I want.
                            </p>
                            <div class="text-warning mb-3">
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star ti-sm"></i>
                            </div>
                            <div class="d-flex align-items-center">
                              <div class="avatar me-2 avatar-sm">
                                <img
                                  src="../../assets/img/avatars/4.png"
                                  alt="Avatar"
                                  class="rounded-circle"
                                />
                              </div>
                              <div>
                                <h6 class="mb-0">Sara Smith</h6>
                                <p class="small text-muted mb-0">
                                  Founder of Continental
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}
                      <div class="swiper-slide">
                        <div class="card h-100">
                          <div class="card-body text-body d-flex flex-column justify-content-between h-100">
                            <div class="mb-3">
                              <img
                                src="../../assets/img/front-pages/branding/logo-5.png"
                                alt="client logo"
                                class="client-logo img-fluid"
                              />
                            </div>
                            <p>
                              “I've never used a theme as versatile and flexible
                              as Vuexy. It's my go to for building dashboard
                              sites on almost any project.”
                            </p>
                            <div class="text-warning mb-3">
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star-filled ti-sm"></i>
                            </div>
                            <div class="d-flex align-items-center">
                              <div class="avatar me-2 avatar-sm">
                                <img
                                  src="../../assets/img/avatars/5.png"
                                  alt="Avatar"
                                  class="rounded-circle"
                                />
                              </div>
                              <div>
                                <h6 class="mb-0">Eugenia Moore</h6>
                                <p class="small text-muted mb-0">
                                  Founder of Hubspot
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div class="swiper-slide">
                        <div class="card h-100">
                          <div class="card-body text-body d-flex flex-column justify-content-between h-100">
                            <div class="mb-3">
                              <img
                                src="../../assets/img/front-pages/branding/logo-6.png"
                                alt="client logo"
                                class="client-logo img-fluid"
                              />
                            </div>
                            <p>
                              Lorem ipsum dolor sit amet consectetur adipisicing
                              elit. Veniam nemo mollitia, ad eum officia numquam
                              nostrum repellendus consequuntur!
                            </p>
                            <div class="text-warning mb-3">
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star-filled ti-sm"></i>
                              <i class="ti ti-star ti-sm"></i>
                            </div>
                            <div class="d-flex align-items-center">
                              <div class="avatar me-2 avatar-sm">
                                <img
                                  src="../../assets/img/avatars/1.png"
                                  alt="Avatar"
                                  class="rounded-circle"
                                />
                              </div>
                              <div>
                                <h6 class="mb-0">Sara Smith</h6>
                                <p class="small text-muted mb-0">
                                  Founder of Continental
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </div>
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr className="m-0" />
         
          <div className="container d-flex justify-content-center align-items-center">
            <div className="swiper-logo-carousel py-4 my-lg-2">
              <div className="swiper" id="swiper-clients-logos">
                <div className="swiper-wrapper d-flex justify-content-center align-items-center">
                  <div className="swiper-slide mx-3">
                    <img
                      src="../../assets/img/front-pages/branding/logo_1-light.png"
                      alt="client logo"
                      className="client-logo"
                      data-app-light-img="front-pages/branding/logo_1-light.png"
                      data-app-dark-img="front-pages/branding/logo_1-dark.png"
                    />
                  </div>
                  <div className="swiper-slide mx-3">
                    <img
                      src="../../assets/img/front-pages/branding/logo_2-light.png"
                      alt="client logo"
                      className="client-logo"
                      data-app-light-img="front-pages/branding/logo_2-light.png"
                      data-app-dark-img="front-pages/branding/logo_2-dark.png"
                    />
                  </div>
                  <div className="swiper-slide mx-3">
                    <img
                      src="../../assets/img/front-pages/branding/logo_3-light.png"
                      alt="client logo"
                      className="client-logo"
                      data-app-light-img="front-pages/branding/logo_3-light.png"
                      data-app-dark-img="front-pages/branding/logo_3-dark.png"
                    />
                  </div>
                  <div className="swiper-slide mx-3">
                    <img
                      src="../../assets/img/front-pages/branding/logo_4-light.png"
                      alt="client logo"
                      className="client-logo"
                      data-app-light-img="front-pages/branding/logo_4-light.png"
                      data-app-dark-img="front-pages/branding/logo_4-dark.png"
                    />
                  </div>
                  <div className="swiper-slide mx-3">
                    <img
                      src="../../assets/img/front-pages/branding/logo_5-light.png"
                      alt="client logo"
                      className="client-logo"
                      data-app-light-img="front-pages/branding/logo_5-light.png"
                      data-app-dark-img="front-pages/branding/logo_5-dark.png"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="landingTeam" className="section-py landing-team">
          <div className="container">
            <div className="text-center mb-3 pb-1">
              <span className="badge bg-label-primary">Our Great Team</span>
            </div>
            <h3 className="text-center mb-1">
              <span className="position-relative fw-bold z-1">
                Supported
                <img
                  src="../../assets/img/front-pages/icons/section-title-icon.png"
                  alt="laptop charging"
                  className="section-title-img position-absolute object-fit-contain bottom-0 z-n1"
                />
              </span>
              by Real People
            </h3>
            <p className="text-center mb-md-5 pb-3">
              Who is behind these great-looking interfaces?
            </p>
            <div className="row gy-5 mt-2">
              <div className="col-lg-3 col-sm-6">
                <div className="card mt-3 mt-lg-0 shadow-none">
                  <div className="bg-label-primary position-relative team-image-box">
                    <img
                      src="../../assets/img/front-pages/landing-page/team-member-1.png"
                      className="position-absolute card-img-position bottom-0 start-50 scaleX-n1-rtl"
                      alt="human image"
                    />
                  </div>
                  <div className="card-body border border-top-0 border-label-primary text-center">
                    <h5 className="card-title mb-0">Sophie Gilbert</h5>
                    <p className="text-muted mb-0">Project Manager</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="card mt-3 mt-lg-0 shadow-none">
                  <div className="bg-label-info position-relative team-image-box">
                    <img
                      src="../../assets/img/front-pages/landing-page/team-member-2.png"
                      className="position-absolute card-img-position bottom-0 start-50 scaleX-n1-rtl"
                      alt="human image"
                    />
                  </div>
                  <div className="card-body border border-top-0 border-label-info text-center">
                    <h5 className="card-title mb-0">Paul Miles</h5>
                    <p className="text-muted mb-0">UI Designer</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="card mt-3 mt-lg-0 shadow-none">
                  <div className="bg-label-danger position-relative team-image-box">
                    <img
                      src="../../assets/img/front-pages/landing-page/team-member-3.png"
                      className="position-absolute card-img-position bottom-0 start-50 scaleX-n1-rtl"
                      alt="human image"
                    />
                  </div>
                  <div className="card-body border border-top-0 border-label-danger text-center">
                    <h5 className="card-title mb-0">Nannie Ford</h5>
                    <p className="text-muted mb-0">Development Lead</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="card mt-3 mt-lg-0 shadow-none">
                  <div className="bg-label-success position-relative team-image-box">
                    <img
                      src="../../assets/img/front-pages/landing-page/team-member-4.png"
                      className="position-absolute card-img-position bottom-0 start-50 scaleX-n1-rtl"
                      alt="human image"
                    />
                  </div>
                  <div className="card-body border border-top-0 border-label-success text-center">
                    <h5 className="card-title mb-0">Chris Watkins</h5>
                    <p className="text-muted mb-0">Marketing Manager</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          id="landingPricing"
          className="section-py bg-body landing-pricing"
        >
          <div className="container">
            <div className="text-center mb-3 pb-1">
              <span className="badge bg-label-primary">Pricing Plans</span>
            </div>
            <h3 className="text-center mb-1">
              <span className="position-relative fw-bold z-1">
                Tailored pricing plans
                <img
                  src="../../assets/img/front-pages/icons/section-title-icon.png"
                  alt="laptop charging"
                  className="section-title-img position-absolute object-fit-contain bottom-0 z-n1"
                />
              </span>
              designed for you
            </h3>
            <p className="text-center mb-4 pb-3">
              All plans include 40+ advanced tools and features to boost your
              product.
              <br />
              Choose the best plan to fit your needs.
            </p>
            <div className="text-center mb-5">
              <div className="position-relative d-inline-block pt-3 pt-md-0">
                <label className="switch switch-primary me-0">
                  <span className="switch-label">Pay Monthly</span>
                  <input
                    type="checkbox"
                    className="switch-input price-duration-toggler"
                    defaultChecked=""
                  />
                  <span className="switch-toggle-slider">
                    <span className="switch-on" />
                    <span className="switch-off" />
                  </span>
                  <span className="switch-label">Pay Annual</span>
                </label>
                <div className="pricing-plans-item position-absolute d-flex">
                  <img
                    src="../../assets/img/front-pages/icons/pricing-plans-arrow.png"
                    alt="pricing plans arrow"
                    className="scaleX-n1-rtl"
                  />
                  <span className="fw-medium mt-2 ms-1"> Save 25%</span>
                </div>
              </div>
            </div>
            <div className="row gy-4 pt-lg-3">
              <div className="col-xl-4 col-lg-6">
                <div className="card">
                  <div className="card-header">
                    <div className="text-center">
                      <img
                        src="../../assets/img/front-pages/icons/paper-airplane.png"
                        alt="paper airplane icon"
                        className="mb-4 pb-2"
                      />
                      <h4 className="mb-1">Basic</h4>
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="price-monthly h1 text-primary fw-bold mb-0">
                          $19
                        </span>
                        <span className="price-yearly h1 text-primary fw-bold mb-0 d-none">
                          $14
                        </span>
                        <sub className="h6 text-muted mb-0 ms-1">/mo</sub>
                      </div>
                      <div className="position-relative pt-2">
                        <div className="price-yearly text-muted price-yearly-toggle d-none">
                          $ 168 / year
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <ul className="list-unstyled">
                      <li>
                        <h5>
                          <span className="badge badge-center rounded-pill bg-label-primary p-0 me-2">
                            <i className="ti ti-check ti-xs" />
                          </span>
                          Timeline
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <span className="badge badge-center rounded-pill bg-label-primary p-0 me-2">
                            <i className="ti ti-check ti-xs" />
                          </span>
                          Basic search
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <span className="badge badge-center rounded-pill bg-label-primary p-0 me-2">
                            <i className="ti ti-check ti-xs" />
                          </span>
                          Live chat widget
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <span className="badge badge-center rounded-pill bg-label-primary p-0 me-2">
                            <i className="ti ti-check ti-xs" />
                          </span>
                          Email marketing
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <span className="badge badge-center rounded-pill bg-label-primary p-0 me-2">
                            <i className="ti ti-check ti-xs" />
                          </span>
                          Custom Forms
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <span className="badge badge-center rounded-pill bg-label-primary p-0 me-2">
                            <i className="ti ti-check ti-xs" />
                          </span>
                          Traffic analytics
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <span className="badge badge-center rounded-pill bg-label-primary p-0 me-2">
                            <i className="ti ti-check ti-xs" />
                          </span>
                          Basic Support
                        </h5>
                      </li>
                    </ul>
                    <div className="d-grid mt-4 pt-3">
                      <a
                        href="payment-page.html"
                        className="btn btn-label-primary"
                      >
                        Get Started
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6">
                <div className="card border border-primary shadow-lg">
                  <div className="card-header">
                    <div className="text-center">
                      <img
                        src="../../assets/img/front-pages/icons/plane.png"
                        alt="plane icon"
                        className="mb-4 pb-2"
                      />
                      <h4 className="mb-1">Team</h4>
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="price-monthly h1 text-primary fw-bold mb-0">
                          $29
                        </span>
                        <span className="price-yearly h1 text-primary fw-bold mb-0 d-none">
                          $22
                        </span>
                        <sub className="h6 text-muted mb-0 ms-1">/mo</sub>
                      </div>
                      <div className="position-relative pt-2">
                        <div className="price-yearly text-muted price-yearly-toggle d-none">
                          $ 264 / year
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <ul className="list-unstyled">
                      <li>
                        <h5>
                          <span className="badge badge-center rounded-pill bg-primary p-0 me-2">
                            <i className="ti ti-check ti-xs" />
                          </span>
                          Everything in basic
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <span className="badge badge-center rounded-pill bg-primary p-0 me-2">
                            <i className="ti ti-check ti-xs" />
                          </span>
                          Timeline with database
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <span className="badge badge-center rounded-pill bg-primary p-0 me-2">
                            <i className="ti ti-check ti-xs" />
                          </span>
                          Advanced search
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <span className="badge badge-center rounded-pill bg-primary p-0 me-2">
                            <i className="ti ti-check ti-xs" />
                          </span>
                          Marketing automation
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <span className="badge badge-center rounded-pill bg-primary p-0 me-2">
                            <i className="ti ti-check ti-xs" />
                          </span>
                          Advanced chatbot
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <span className="badge badge-center rounded-pill bg-primary p-0 me-2">
                            <i className="ti ti-check ti-xs" />
                          </span>
                          Campaign management
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <span className="badge badge-center rounded-pill bg-primary p-0 me-2">
                            <i className="ti ti-check ti-xs" />
                          </span>
                          Collaboration tools
                        </h5>
                      </li>
                    </ul>
                    <div className="d-grid mt-4 pt-3">
                      <a href="payment-page.html" className="btn btn-primary">
                        Get Started
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6">
                <div className="card">
                  <div className="card-header">
                    <div className="text-center">
                      <img
                        src="../../assets/img/front-pages/icons/shuttle-rocket.png"
                        alt="shuttle rocket icon"
                        className="mb-4 pb-2"
                      />
                      <h4 className="mb-1">Enterprise</h4>
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="price-monthly h1 text-primary fw-bold mb-0">
                          $49
                        </span>
                        <span className="price-yearly h1 text-primary fw-bold mb-0 d-none">
                          $37
                        </span>
                        <sub className="h6 text-muted mb-0 ms-1">/mo</sub>
                      </div>
                      <div className="position-relative pt-2">
                        <div className="price-yearly text-muted price-yearly-toggle d-none">
                          $ 444 / year
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <ul className="list-unstyled">
                      <li>
                        <h5>
                          <span className="badge badge-center rounded-pill bg-label-primary p-0 me-2">
                            <i className="ti ti-check ti-xs" />
                          </span>
                          Everything in premium
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <span className="badge badge-center rounded-pill bg-label-primary p-0 me-2">
                            <i className="ti ti-check ti-xs" />
                          </span>
                          Timeline with database
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <span className="badge badge-center rounded-pill bg-label-primary p-0 me-2">
                            <i className="ti ti-check ti-xs" />
                          </span>
                          Fuzzy search
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <span className="badge badge-center rounded-pill bg-label-primary p-0 me-2">
                            <i className="ti ti-check ti-xs" />
                          </span>
                          A/B testing sanbox
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <span className="badge badge-center rounded-pill bg-label-primary p-0 me-2">
                            <i className="ti ti-check ti-xs" />
                          </span>
                          Custom permissions
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <span className="badge badge-center rounded-pill bg-label-primary p-0 me-2">
                            <i className="ti ti-check ti-xs" />
                          </span>
                          Social media automation
                        </h5>
                      </li>
                      <li>
                        <h5>
                          <span className="badge badge-center rounded-pill bg-label-primary p-0 me-2">
                            <i className="ti ti-check ti-xs" />
                          </span>
                          Sales automation tools
                        </h5>
                      </li>
                    </ul>
                    <div className="d-grid mt-4 pt-3">
                      <a
                        href="payment-page.html"
                        className="btn btn-label-primary"
                      >
                        Get Started
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="landingFunFacts" className="section-py landing-fun-facts">
          <div className="container">
            <div className="row gy-3">
              <div className="col-sm-6 col-lg-3">
                <div className="card border border-label-primary shadow-none">
                  <div className="card-body text-center">
                    <img
                      src="../../assets/img/front-pages/icons/laptop.png"
                      alt="laptop"
                      className="mb-2"
                    />
                    <h5 className="h2 mb-1">7.1k+</h5>
                    <p className="fw-medium mb-0">
                      Support Tickets
                      <br />
                      Resolved
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-lg-3">
                <div className="card border border-label-success shadow-none">
                  <div className="card-body text-center">
                    <img
                      src="../../assets/img/front-pages/icons/user-success.png"
                      alt="laptop"
                      className="mb-2"
                    />
                    <h5 className="h2 mb-1">50k+</h5>
                    <p className="fw-medium mb-0">
                      Join creatives
                      <br />
                      community
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-lg-3">
                <div className="card border border-label-info shadow-none">
                  <div className="card-body text-center">
                    <img
                      src="../../assets/img/front-pages/icons/diamond-info.png"
                      alt="laptop"
                      className="mb-2"
                    />
                    <h5 className="h2 mb-1">4.8/5</h5>
                    <p className="fw-medium mb-0">
                      Highly Rated
                      <br />
                      Products
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-lg-3">
                <div className="card border border-label-warning shadow-none">
                  <div className="card-body text-center">
                    <img
                      src="../../assets/img/front-pages/icons/check-warning.png"
                      alt="laptop"
                      className="mb-2"
                    />
                    <h5 className="h2 mb-1">100%</h5>
                    <p className="fw-medium mb-0">
                      Money Back
                      <br />
                      Guarantee
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="landingFAQ" className="section-py bg-body landing-faq">
          <div className="container">
            <div className="text-center mb-3 pb-1">
              <span className="badge bg-label-primary">FAQ</span>
            </div>
            <h3 className="text-center mb-1">
              Frequently asked
              <span className="position-relative fw-bold z-1">
                questions
                <img
                  src="../../assets/img/front-pages/icons/section-title-icon.png"
                  alt="laptop charging"
                  className="section-title-img position-absolute object-fit-contain bottom-0 z-n1"
                />
              </span>
            </h3>
            <p className="text-center mb-5 pb-3">
              Browse through these FAQs to find answers to commonly asked
              questions.
            </p>
            <div className="row gy-5">
              <div className="col-lg-5">
                <div className="text-center">
                  <img
                    src="../../assets/img/front-pages/landing-page/faq-boy-with-logos.png"
                    alt="faq boy with logos"
                    className="faq-image"
                  />
                </div>
              </div>
              <div className="col-lg-7">
                <div className="accordion" id="accordionExample">
                  <div className="card accordion-item active">
                    <h2 className="accordion-header" id="headingOne">
                      <button
                        type="button"
                        className="accordion-button"
                        data-bs-toggle="collapse"
                        data-bs-target="#accordionOne"
                        aria-expanded="true"
                        aria-controls="accordionOne"
                      >
                        Do you charge for each upgrade?
                      </button>
                    </h2>
                    <div
                      id="accordionOne"
                      className="accordion-collapse collapse show"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lemon drops chocolate cake gummies carrot cake chupa
                        chups muffin topping. Sesame snaps icing marzipan gummi
                        bears macaroon dragée danish caramels powder. Bear claw
                        dragée pastry topping soufflé. Wafer gummi bears
                        marshmallow pastry pie.
                      </div>
                    </div>
                  </div>
                  <div className="card accordion-item">
                    <h2 className="accordion-header" id="headingTwo">
                      <button
                        type="button"
                        className="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#accordionTwo"
                        aria-expanded="false"
                        aria-controls="accordionTwo"
                      >
                        Do I need to purchase a license for each website?
                      </button>
                    </h2>
                    <div
                      id="accordionTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Dessert ice cream donut oat cake jelly-o pie sugar plum
                        cheesecake. Bear claw dragée oat cake dragée ice cream
                        halvah tootsie roll. Danish cake oat cake pie macaroon
                        tart donut gummies. Jelly beans candy canes carrot cake.
                        Fruitcake chocolate chupa chups.
                      </div>
                    </div>
                  </div>
                  <div className="card accordion-item">
                    <h2 className="accordion-header" id="headingThree">
                      <button
                        type="button"
                        className="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#accordionThree"
                        aria-expanded="false"
                        aria-controls="accordionThree"
                      >
                        What is regular license?
                      </button>
                    </h2>
                    <div
                      id="accordionThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Regular license can be used for end products that do not
                        charge users for access or service(access is free and
                        there will be no monthly subscription fee). Single
                        regular license can be used for single end product and
                        end product can be used by you or your client. If you
                        want to sell end product to multiple clients then you
                        will need to purchase separate license for each client.
                        The same rule applies if you want to use the same end
                        product on multiple domains(unique setup). For more info
                        on regular license you can check official description.
                      </div>
                    </div>
                  </div>
                  <div className="card accordion-item">
                    <h2 className="accordion-header" id="headingFour">
                      <button
                        type="button"
                        className="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#accordionFour"
                        aria-expanded="false"
                        aria-controls="accordionFour"
                      >
                        What is extended license?
                      </button>
                    </h2>
                    <div
                      id="accordionFour"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Nobis et aliquid quaerat possimus maxime! Mollitia
                        reprehenderit neque repellat deleniti delectus
                        architecto dolorum maxime, blanditiis earum ea, incidunt
                        quam possimus cumque.
                      </div>
                    </div>
                  </div>
                  <div className="card accordion-item">
                    <h2 className="accordion-header" id="headingFive">
                      <button
                        type="button"
                        className="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#accordionFive"
                        aria-expanded="false"
                        aria-controls="accordionFive"
                      >
                        Which license is applicable for SASS application?
                      </button>
                    </h2>
                    <div
                      id="accordionFive"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFive"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum dolor sit amet consectetur, adipisicing
                        elit. Sequi molestias exercitationem ab cum nemo facere
                        voluptates veritatis quia, eveniet veniam at et
                        repudiandae mollitia ipsam quasi labore enim architecto
                        non!
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          id="landingCTA"
          className="section-py landing-cta position-relative p-lg-0 pb-0"
        >
          <img
            src="../../assets/img/front-pages/backgrounds/cta-bg-light.png"
            className="position-absolute bottom-0 end-0 scaleX-n1-rtl h-100 w-100 z-n1"
            alt="cta image"
            data-app-light-img="front-pages/backgrounds/cta-bg-light.png"
            data-app-dark-img="front-pages/backgrounds/cta-bg-dark.png"
          />
          <div className="container">
            <div className="row align-items-center gy-5 gy-lg-0">
              <div className="col-lg-6 text-center text-lg-start">
                <h6 className="h2 text-primary fw-bold mb-1">
                  Ready to Get Started?
                </h6>
                <p className="fw-medium mb-4">
                  Start your project with a 14-day free trial
                </p>
                <a href="payment-page.html" className="btn btn-lg btn-primary">
                  Get Started
                </a>
              </div>
              <div className="col-lg-6 pt-lg-5 text-center text-lg-end">
                <img
                  src="../../assets/img/front-pages/landing-page/cta-dashboard.png"
                  alt="cta dashboard"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
        </section>

        <section
          id="landingContact"
          className="section-py bg-body landing-contact"
        >
          <div className="container">
            <div className="text-center mb-3 pb-1">
              <span className="badge bg-label-primary">Contact US</span>
            </div>
            <h3 className="text-center mb-1">
              <span className="position-relative fw-bold z-1">
                Let's work
                <img
                  src="../../assets/img/front-pages/icons/section-title-icon.png"
                  alt="laptop charging"
                  className="section-title-img position-absolute object-fit-contain bottom-0 z-n1"
                />
              </span>
              together
            </h3>
            <p className="text-center mb-4 mb-lg-5 pb-md-3">
              Any question or remark? just write us a message
            </p>
            <div className="row gy-4">
              <div className="col-lg-5">
                <div className="contact-img-box position-relative border p-2 h-100">
                  <img
                    src="../../assets/img/front-pages/icons/contact-border.png"
                    alt="contact border"
                    className="contact-border-img position-absolute d-none d-md-block scaleX-n1-rtl"
                  />
                  <img
                    src="../../assets/img/front-pages/landing-page/contact-customer-service.png"
                    alt="contact customer service"
                    className="contact-img w-100 scaleX-n1-rtl"
                  />
                  <div className="pt-3 px-4 pb-1">
                    <div className="row gy-3 gx-md-4">
                      <div className="col-md-6 col-lg-12 col-xl-6">
                        <div className="d-flex align-items-center">
                          <div className="badge bg-label-primary rounded p-2 me-2">
                            <i className="ti ti-mail ti-sm" />
                          </div>
                          <div>
                            <p className="mb-0">Email</p>
                            <h5 className="mb-0">
                              <a
                                href="mailto:example@gmail.com"
                                className="text-heading"
                              >
                                example@gmail.com
                              </a>
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-12 col-xl-6">
                        <div className="d-flex align-items-center">
                          <div className="badge bg-label-success rounded p-2 me-2">
                            <i className="ti ti-phone-call ti-sm" />
                          </div>
                          <div>
                            <p className="mb-0">Phone</p>
                            <h5 className="mb-0">
                              <a
                                href="tel:+1234-568-963"
                                className="text-heading"
                              >
                                +1234 568 963
                              </a>
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="card">
                  <div className="card-body">
                    <h4 className="mb-1">Send a message</h4>
                    <p className="mb-4">
                      If you would like to discuss anything related to payment,
                      account, licensing,
                      <br className="d-none d-lg-block" />
                      partnerships, or have pre-sales questions, you’re at the
                      right place.
                    </p>
                    <form>
                      <div className="row g-3">
                        <div className="col-md-6">
                          <label
                            className="form-label"
                            htmlFor="contact-form-fullname"
                          >
                            Full Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="contact-form-fullname"
                            placeholder="john"
                          />
                        </div>
                        <div className="col-md-6">
                          <label
                            className="form-label"
                            htmlFor="contact-form-email"
                          >
                            Email
                          </label>
                          <input
                            type="text"
                            id="contact-form-email"
                            className="form-control"
                            placeholder="johndoe@gmail.com"
                          />
                        </div>
                        <div className="col-12">
                          <label
                            className="form-label"
                            htmlFor="contact-form-message"
                          >
                            Message
                          </label>
                          <textarea
                            id="contact-form-message"
                            className="form-control"
                            rows={8}
                            placeholder="Write a message"
                            defaultValue={""}
                          />
                        </div>
                        <div className="col-12">
                          <button type="submit" className="btn btn-primary">
                            Send inquiry
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <HomeFooter />
      </div>
    </>
  );
};

export default Test;
